export default "__VITE_ASSET__DfF4qoQ0__"